<template>
  <div v-if="step === activeStep">
    <slot />

    <StepperButtons v-if="showButtons" :active-step="activeStep" :steps="steps" @set-step="setStep" />
  </div>
</template>

<script>
import StepperButtons from './StepperButtons';
// @vuese
// Sekcje kroków formularzy
// @group MaterialStepper
export default {
  components: { StepperButtons },
  props: {
    // Aktualny krok
    activeStep: { type: Number, required: true },
    // Kroki
    steps: { type: Array, required: true },
    // Krok danej sekcji
    step: { type: Number, required: true },
    // czy pokazywać przyciski wstecz/dalej
    showButtons: { type: Boolean, default: true }
  },
  methods: {
    setStep(value) {
      this.$emit('set-step', value);
    }
  }
};
</script>
